import { STORE } from "@/lib/config";
import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-neutral-950 text-white/70 border-t border-white/10 py-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div
              className="text-white font-extrabold text-2xl mb-2"
              style={{ fontFamily: "Cabinet Grotesk" }}
            >
              {STORE.name} <span className="text-[#D32F2F]">{STORE.city}</span>
            </div>
            <p className="text-sm leading-relaxed">{STORE.tagline}</p>
          </div>
          <div className="space-y-2 text-sm">
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-[#D32F2F]" />
              {STORE.address}
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#D32F2F]" />
              {STORE.phone}
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#D32F2F]" />
              {STORE.email}
            </div>
          </div>
          <div className="flex md:justify-end items-start gap-3">
            <a
              href={STORE.facebook.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 grid place-items-center bg-white/5 hover:bg-[#1877F2] rounded-full transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href={STORE.instagram.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 grid place-items-center bg-white/5 hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] rounded-full transition-all"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/40">
          <div>© {new Date().getFullYear()} {STORE.name} {STORE.city}. Sva prava pridržana.</div>
          <div>Od 2004. — sa povjerenjem.</div>
        </div>
      </div>
    </footer>
  );
}
